import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages
} from '~/shared/src/utilities/dataExtraction';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type LayerType = 'standard' | 'satellite' | 'opnv' | 'topo';


// CFG:Map
export type Map = {
    data : {
        id : number;
        key : string;
        name : string;

        loadRequestCommand : string;
        loadRequestModule : string;
        loadRequestParams? : {
            [ key : string ] : string;
        };

        fitBounds : boolean;
        layerType : LayerType;
    };
    images : Images;
    messages : Messages;
    permissions : GroupPermissions;
};
export const mapDataProps = keys<Map['data']>();
export const mapProps = keys<Map>();
export const requiredMapProps = keys<RequiredOf<Map>>();
